import Temp from "@/courier/Temp";
import courierRules from "../constants/CourierRules";

export default class FlashExpressBulky extends Temp {
  static CODE = "FLEB";

  constructor() {
    super(FlashExpressBulky.CODE);
  }

  listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));

  getZone(item, courier) {
    // replace ทุ่งปี๊ -> ทุ่งปี้ เพราะ address flash ใช้ปี้ เกิดมาเพื่อน้องแฟลชคนเดียว
    if (item.to.state == 'ทุ่งปี๊') {
      item.to.state = 'ทุ่งปี้';
    }
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let travel_surcharge = 0;
    let island_surcharge = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));
    island_surcharge = super.checkIslandSurcharge(Number(item.toPostcode));
    if (travel_surcharge) {
      if (new Date().getTime() > new Date('2023-04-08 00:00:00').getTime()) {
        if (item.weight > 20000) {
          travel_surcharge = 200;
        } else if (item.weight > 7000) {
          travel_surcharge = 100;
        } else {
          travel_surcharge = 30;
        }
      } else {
        if (item.weight > 50000) {
          travel_surcharge = 150;
        } else if (item.weight > 30000) {
          travel_surcharge = 100;
        } else {
          travel_surcharge = 50;
        }
      }
    }

    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);

    from = super.checkZone(prefixFromPostCode);
    to = super.checkZone(prefixToPostCode);
    if (["94", "95", "96"].indexOf(prefixToPostCode) > -1) {
      remote_area = this.listPostcodeSpecial[FlashExpressBulky.CODE].remotearea
        .special.cost;
    }

    if (
      ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
      ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
    ) {
      remote_area = 0;
    }
    const sameProvince = this.checkSameProvince(item);
    // 1 = กทม. BKK
    // 2 = ภาคกลาง C
    // 3 = เหนือ N
    // 4 = ภาคอีสาน NE
    // 5 = ภาคใต้ S
    const nameType = {
      BKK_TO_BKK: 1,
      BKK_TO_UPC: 2,
      UPC_WITH_SAME_PROVINCE: 3,
      UPC_TO_UPC: 4,
      UPC_TO_BKK: 5,
    };
    if (to == 1 && from == 1) {
      type = nameType["BKK_TO_BKK"];
    } else if (from == 1 && [2, 3, 4, 5].includes(to)) {
      type = nameType["BKK_TO_UPC"];
    } else if (
      sameProvince &&
      [2, 3, 4, 5].includes(from) &&
      [2, 3, 4, 5].includes(to)
    ) {
      type = nameType["UPC_WITH_SAME_PROVINCE"];
    } else if ([2, 3, 4, 5].includes(from) && [2, 3, 4, 5].includes(to)) {
      type = nameType["UPC_TO_UPC"];
    } else if ([2, 3, 4, 5].includes(from) && to == 1) {
      type = nameType["UPC_TO_BKK"];
    }
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      travel_surcharge: travel_surcharge,
      island_surcharge: island_surcharge,
      cross_price: cross_price,
    };
  }
  checkRuleDimensionWeight(type, item) {
    const rule = FlashExpressBulky.RULE_DIMENSION_WEIGHT[type]
      ? FlashExpressBulky.RULE_DIMENSION_WEIGHT[type]
      : false;
    if (!rule) return rule;
    return (
      +item.weight < rule.max_weight && +item.culculateSize < rule.max_dimension
    );
  }
  checkSameProvince(item) {
    return (
      (!item.source && item.province.sameData == item.province.to) ||
      (item.source && item.province.from == item.province.to)
    );
  }
  checkWeight(courierRates, item, validate) {
    if (!courierRates) return {index: -1};
    let dimensionWeight = super.calculateDimensionWeight(item);
    console.log('fleb dimw=>', dimensionWeight)
    let useWeight = 0;
    useWeight = dimensionWeight > item.weight ? dimensionWeight : item.weight;
    const maxTier = courierRates[courierRates.length - 1];

    if (useWeight > maxTier.max) {
      useWeight = item.weight;
    }
    item.index = courierRates.findIndex((rate) => {
      return useWeight >= rate.min && useWeight <= rate.max;
    });
    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      let weight = option.weight;
      super.getArea([addressRemote], ["FLEB"], option).then((res) => {
        let weight = option.weight;
        if (weight < ((option.price && option.price.selectedTier) ? option.price.selectedTier.max : 0)) {
          weight = option.price.selectedTier.max
        }
        let returnRate = {
          isRemote: res.data.FLEB.is_remote?50:0,
          isTravelArea: 0,
          isIsland: res.data.FLEB.is_island?30:0
        };
        if (res.data.FLEB.is_remote) {
          if (weight > 100000) {
            let overKG = super.calculateOverweight(weight, 100000, 50000);
            // let overKG = Math.ceil((weight - 100000)/1000/50);
            returnRate.isRemote = 200 + (overKG * 50);
          } else if (weight > 70000) {
            returnRate.isRemote = 200;
          } else if (weight > 50000) {
            returnRate.isRemote = 100;
          } else {
            returnRate.isRemote = 50;
          }
        }
        if (res.data.FLEB.is_tourist) {
          if (weight > 20000) {
            returnRate.isTravelArea = 200;
          } else if (weight > 7000) {
            returnRate.isTravelArea = 100;
          } else {
            returnRate.isTravelArea = 30;
          }
        }
        resolve(returnRate);
      });
    });
  }
}
